// extracted by mini-css-extract-plugin
export var colorSquare = "_r9-0";
export var danger = "_r9-5";
export var lightPink = "_r9-8";
export var neutralBlue = "_r9-7";
export var neutralYellow = "_r9-6";
export var normal = "_r9-1";
export var primary = "_r9-2";
export var primaryLight = "_r9-3";
export var solidBlack = "_r9-g";
export var solidGreen = "_r9-b";
export var solidLightBlue = "_r9-d";
export var solidNavy = "_r9-c";
export var solidOrange = "_r9-f";
export var solidPink = "_r9-e";
export var solidRed = "_r9-9";
export var solidYellow = "_r9-a";
export var success = "_r9-4";